import React, { useState, useEffect } from 'react';
import { Progress } from 'antd';
import clsx from 'clsx';

interface IndeterminateProgressProps {
  className?: string;
}

function IndeterminateProgress({ className }: IndeterminateProgressProps) {
  return (
    <div className={className}>
      <div className='h-1.5 w-full bg-blue-dark/10 overflow-hidden'>
        <div className='animate-progress-indeterminate w-full h-full bg-blue-dark left-right'></div>
      </div>
    </div>
  );
}

export default IndeterminateProgress;